module.exports = __webpack_public_path__ + "static/media/fitness-icon.59e06734.svg";